import * as c from '../../constants/app';
import * as pages from '../../constants/pages';
import {
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGOUT_FAILURE,
  AUTH_LOGOUT_START,
  AUTH_LOGOUT_SUCCESS,
} from '../../constants/auth';
import {
  GAME_LEVEL_UP_SUCCESS,
  GAME_CHANGE_LEVEL_SUCCESS,
} from '../../constants/game';
import { FM_SHOW } from '../../constants/filemanager';

export const defaultState = {
  initialized: false,
  loading: true,
  code: '',
  name: '',
  designFields: [],
  contentLevel: 1,
  simulationAllowed: false,
  showQuizSummary: true,
  gameMode: false,
  specification: {},
  page: pages.PAGE_HOME,
  appList: [],
  error: undefined,
  showTour: false,
  tourStep: 0,
};

const app = (state = defaultState, action) => {
  switch (action.type) {
    case c.APP_SET_INITIALIZED:
      return { ...state, initialized: !!action.initialized };
    case c.APP_SET_LOADING:
      return { ...state, loading: !!action.loading };
    case c.APP_INITIALIZE_START:
      return { ...state, loading: true };
    case c.APP_INITIALIZE_FAILURE:
      return { ...state, loading: false, initialized: false };
    case c.APP_INITIALIZE_SUCCESS:
      return { ...state, initialized: true };
    case c.APP_SET_INFO:
      const {
        code,
        name,
        contentLevel,
        specification,
        simulationAllowed,
        showQuizSummary,
        hasDistrict,
        gameMode,
        competition,
        designFields,
      } = action;
      return {
        ...state,
        code,
        name,
        contentLevel,
        specification,
        simulationAllowed,
        showQuizSummary,
        hasDistrict,
        gameMode,
        competition,
        designFields,
      };
    case c.APP_SET_PAGE:
      if (pages[action.page]) {
        return {
          ...state,
          page: action.page,
          showTour: state.tourStep > 0 && !state.showTour,
        };
      } else {
        return state;
      }
    case FM_SHOW:
      const runningTour = state.tourStep > 0 && !state.showTour;
      return {
        ...state,
        showTour: runningTour,
        tourStep: runningTour ? state.tourStep + 1 : 0,
      };
    case c.APP_GET_APPLIST:
      return { ...state, loading: true };
    case c.APP_GET_APPLIST_SUCCESS:
      if (state.code) {
        return {
          ...state,
          error: undefined,
          appList: action.result,
        };
      } else {
        return {
          ...state,
          error: undefined,
          loading: false,
          appList: action.result,
        };
      }
    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
      };
    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    case AUTH_LOGOUT_START:
    case AUTH_LOGOUT_FAILURE:
    case AUTH_LOGOUT_SUCCESS:
    case c.APP_REFRESH_ACTIVITY_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case c.APP_GET_APPLIST_FAILURE:
      return { ...state, loading: false, error: action.error };
    case c.APP_SET_SHOW_TOUR:
      return { ...state, showTour: action.show };
    case c.APP_SET_TOUR_STEP:
      return { ...state, tourStep: action.stepIndex };
    case c.APP_REFRESH_ACTIVITY_SUCCESS:
    case GAME_LEVEL_UP_SUCCESS:
    case GAME_CHANGE_LEVEL_SUCCESS:
      return {
        ...state,
        specification: action.result.activity.specification,
      };
    default:
      return state;
  }
};

export default app;
